module.exports = __webpack_public_path__ + "OpenSans-ExtraBoldItalic-4f44077586ec12a35ce6778e879d43da.woff";